import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'job', en);

const JobCorrectConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Correction',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.JOB,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/job/correct/:id',
      component: React.lazy(() => import('./JobCorrect')),
    },
  ],
};

export default JobCorrectConfig;
